// JavaScript source code
import { useEffect, useState, useRef } from 'react';
import { GameTile, NewGameTile } from "../components/library/Game.js"
import "../styles/AccountComponents/GameTileSelect.css";

function GameTileSelect({ GameEntries }) {

    return (
        <div className="mainTileSelect" >
            <div className="tileContainer">
                {GameEntries !== undefined &&
                    GameEntries.map((game, index) => {
                        return <GameTile gameId={game} />
                    })
                }
                <NewGameTile />
            </div>
        </div >
    );
}

export default GameTileSelect;